function playWithControls(evt){
    const video = evt.target.closest('video-media').querySelector('video');
    console.log(video)
    video.controls = true;
    video.muted = false;
    video.play();
}

// WCAG: Fix Sezzle button accessibility
(function() {
  function fixSezzleButtons() {
    // Find all Sezzle buttons with role="button" and aria-haspopup="dialog"
    const sezzleButtons = document.querySelectorAll('.sezzle-checkout-button-wrapper[role="button"][aria-haspopup="dialog"]');
    sezzleButtons.forEach(function(button) {
      // Check if button already has an accessible name
      const hasAriaLabel = button.getAttribute('aria-label');
      const hasAriaLabelledBy = button.getAttribute('aria-labelledby');
      const hasTextContent = button.textContent && button.textContent.trim();
      
      // If no accessible name exists, add one
      if (!hasAriaLabel && !hasAriaLabelledBy) {
        // Try to get descriptive text from child elements
        const buttonText = button.querySelector('.sezzle-button-text')?.textContent?.trim() ||
                          button.querySelector('.sezzle-text')?.textContent?.trim() ||
                          button.textContent?.trim();
        
        // Create a descriptive aria-label
        let ariaLabel = 'Learn more about Sezzle payment options';
        if (buttonText && buttonText.length > 0) {
          // If there's text, make it more descriptive
          ariaLabel = buttonText + ' - Learn more about Sezzle payment options';
        }
        
        button.setAttribute('aria-label', ariaLabel);
      }
    });
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixSezzleButtons);
  } else {
    fixSezzleButtons();
  }
  
  // Run after dynamic content loads (for AJAX-loaded product pages)
  const observer = new MutationObserver(function(mutations) {
    let shouldFix = false;
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            if (node.matches && node.matches('.sezzle-checkout-button-wrapper[role="button"][aria-haspopup="dialog"]')) {
              shouldFix = true;
            }
            if (node.querySelectorAll) {
              const buttons = node.querySelectorAll('.sezzle-checkout-button-wrapper[role="button"][aria-haspopup="dialog"]');
              if (buttons.length > 0) {
                shouldFix = true;
              }
            }
          }
        });
      }
      // Also watch for attribute changes on existing buttons
      if (mutation.type === 'attributes' && 
          mutation.target.matches && 
          mutation.target.matches('.sezzle-checkout-button-wrapper[role="button"][aria-haspopup="dialog"]')) {
        shouldFix = true;
      }
    });
    
    if (shouldFix) {
      fixSezzleButtons();
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-label', 'aria-labelledby', 'role', 'aria-haspopup']
  });
  
  // Also check periodically for dynamically loaded Sezzle widgets
  setInterval(function() {
    const buttons = document.querySelectorAll('.sezzle-checkout-button-wrapper[role="button"][aria-haspopup="dialog"]:not([aria-label]):not([aria-labelledby])');
    if (buttons.length > 0) {
      fixSezzleButtons();
    }
  }, 1000);
})();

// WCAG: Fix aria-hidden-focus for announcement bar slides
(function() {
  function updateAnnouncementSlideFocus() {
    const slides = document.querySelectorAll('.announcement__slide');
    slides.forEach(function(slide) {
      const isHidden = slide.getAttribute('aria-hidden') === 'true';
      const link = slide.querySelector('a.announcement__content');
      if (link) {
        if (isHidden) {
          link.setAttribute('tabindex', '-1');
        } else {
          link.removeAttribute('tabindex');
        }
      }
    });
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      updateAnnouncementSlideFocus();
      
      // Listen for slider changes
      document.querySelectorAll('announcement-bar').forEach(function(bar) {
        bar.addEventListener('slider:change', updateAnnouncementSlideFocus);
      });
    });
  } else {
    updateAnnouncementSlideFocus();
    
    // Listen for slider changes
    document.querySelectorAll('announcement-bar').forEach(function(bar) {
      bar.addEventListener('slider:change', updateAnnouncementSlideFocus);
    });
  }
  
  // Watch for aria-hidden changes on announcement slides
  const announcementObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
        const slide = mutation.target;
        if (slide.classList.contains('announcement__slide')) {
          const isHidden = slide.getAttribute('aria-hidden') === 'true';
          const link = slide.querySelector('a.announcement__content');
          if (link) {
            if (isHidden) {
              link.setAttribute('tabindex', '-1');
            } else {
              link.removeAttribute('tabindex');
            }
          }
        }
      }
    });
  });
  
  // Observe all announcement slides
  document.querySelectorAll('.announcement__slide').forEach(function(slide) {
    announcementObserver.observe(slide, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  });
  
  // Also observe for dynamically added slides
  const dynamicObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          if (node.classList && node.classList.contains('announcement__slide')) {
            announcementObserver.observe(node, {
              attributes: true,
              attributeFilter: ['aria-hidden']
            });
            updateAnnouncementSlideFocus();
          }
          // Check for slides within added nodes
          node.querySelectorAll && node.querySelectorAll('.announcement__slide').forEach(function(slide) {
            announcementObserver.observe(slide, {
              attributes: true,
              attributeFilter: ['aria-hidden']
            });
          });
        }
      });
    });
  });
  
  dynamicObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

